export const SIGNATURE_CONTEXT = {
    SHARE_CALENDAR_INVITE: 'calendar.sharing.invite'
};
